import * as React from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource-variable/inter-tight';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/900.css';
import { rewriteLegacyHashRouterUrl } from './legacyHashRouterRedirect';
import { RootWidget } from './widgets/layout/RootWidget';

document.addEventListener('DOMContentLoaded', () => {
  rewriteLegacyHashRouterUrl();
  const root = createRoot(document.querySelector('#application'));
  root.render(<RootWidget />);
});
